
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as Utils from '@root-utils/index';


// component
const Component: React.FunctionComponent<any> = (props: InterfaceClassFive<any>): JSX.Element =>{

    const { items , onOponFive} = props;
    const percentage =items && items.prod &&  items.prod.score_classif*100;
    const percent =percentage && percentage.toFixed(1)

    return(
        
        <li className="items-cart items-cart-class-5">
            <div className="items-cart-class-5-image-url" onClick={onOponFive}><img src={items && items.prod.image_url && items.prod.image_url} alt=""/></div>
            <div className="items-cart-class-5-stats">
                <div className="items-cart--stats">
                    <span>
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.54894 0.927052C7.8483 0.0057416 9.1517 0.00573945 9.45106 0.92705L10.6329 4.56434C10.7668 4.97636 11.1507 5.25532 11.5839 5.25532H15.4084C16.3771 5.25532 16.7799 6.49494 15.9962 7.06434L12.9021 9.31231C12.5516 9.56695 12.405 10.0183 12.5389 10.4303L13.7207 14.0676C14.02 14.9889 12.9656 15.7551 12.1818 15.1857L9.08779 12.9377C8.7373 12.6831 8.2627 12.6831 7.91222 12.9377L4.81815 15.1857C4.03444 15.7551 2.97996 14.9889 3.27931 14.0676L4.46114 10.4303C4.59501 10.0183 4.44835 9.56695 4.09787 9.31231L1.00381 7.06434C0.220092 6.49494 0.622867 5.25532 1.59159 5.25532H5.41606C5.84929 5.25532 6.23324 4.97636 6.36712 4.56434L7.54894 0.927052Z" fill="#E4E8EA"/>
                        </svg>
                    </span>
                    <span>{items && percent } %</span>
                </div>
            </div>
            <div className="items-cart-class-5-stats">
                <div className="items-cart--stats">
                    <span>
                        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14 1.58203V0H0V1.58203C0 2.27109 0.448718 2.85469 1.07692 3.07266V14.9273C0.448718 15.1453 0 15.7289 0 16.418V18H14V16.418C14 15.7289 13.5513 15.1453 12.9231 14.9273V3.07266C13.5513 2.85469 14 2.27109 14 1.58203ZM10.7692 14.8359V12.8039C10.7692 11.5664 10.141 10.4203 9.08923 9.73125L7.96923 9L9.08923 8.26875C10.141 7.5832 10.7692 6.43359 10.7692 5.19609V3.16406H11.8462V14.8359H10.7692ZM3.23077 3.16406V5.19609C3.23077 6.43359 3.85897 7.57969 4.91077 8.26875L6.03077 9L4.91077 9.73125C3.85897 10.4168 3.23077 11.5664 3.23077 12.8039V14.8359H2.15385V3.16406H3.23077Z" fill="#E4E8EA"/>
                        </svg>

                    </span>
                    <span>{items && items.prod.pred_time} ms</span>
                </div>
            </div>
            <div className="items-cart-class-5-stats">
                <div className="items-cart--stats">
                    <span>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.5 0C3.808 0 0 3.808 0 8.5C0 13.192 3.808 17 8.5 17C13.192 17 17 13.192 17 8.5C17 3.808 13.192 0 8.5 0ZM12.172 10.115H8.568C8.55667 10.115 8.54533 10.1093 8.534 10.1093C8.52267 10.1093 8.51133 10.115 8.5 10.115C8.177 10.115 7.91067 9.85433 7.91067 9.52567V3.52467C7.91067 3.20167 8.17133 2.93533 8.5 2.93533C8.82867 2.93533 9.08933 3.196 9.08933 3.52467V8.93633H12.1777C12.5007 8.93633 12.767 9.197 12.767 9.52567C12.7613 9.85433 12.5007 10.115 12.172 10.115Z" fill="#E4E8EA"/>
                        </svg>
                    </span>
                    <span>{items && Utils.localDateFrSecondFormat(items['@timestamp'])}</span>
                </div>
            </div>
            <div className="items-cart-class-5-stats">
                <div className="items-cart--stats">
                    <span>
                        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 0C2.69256 0 0 2.76277 0 6.15646C0 10.3703 5.36893 16.5567 5.5987 16.8157C5.8123 17.0614 6.1877 17.0614 6.40129 16.8157C6.63107 16.5534 12 10.3703 12 6.15646C12.0032 2.76277 9.31068 0 6 0ZM6 9.25462C4.33657 9.25462 2.98058 7.86327 2.98058 6.15646C2.98058 4.44965 4.33657 3.05831 6 3.05831C7.66343 3.05831 9.01942 4.44965 9.01942 6.15646C9.01942 7.86327 7.66667 9.25462 6 9.25462Z" fill="#E4E8EA"/>
                        </svg>
                    </span>
                    <span>{items && items.stationName}</span>
                </div>
            </div>
        </li>
    )
}

// interface 
export interface InterfaceClassFive<T>{
    items?:T,
    onOponFive?: any
}

/**
 * DefaultProps values
 */
Component.defaultProps= {

}

export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@widgets/classFive/component.tsx